import {writable} from 'svelte/store';

const data = {container: false, current: false};
const widget = writable(data);

widget.getData = () => data;
widget.setData = data => {
	widget.set(data);
};

export default widget;